import { isIpValid } from 'core/util/ip';
import { PRIVATE_SUBNETS } from '@kentik/ui-shared/networkClassification/constants';

function isPrivate(address) {
  return PRIVATE_SUBNETS.reduce(
    (res, privateSubnet) => res || address.isInSubnet(isIpValid(privateSubnet, { returnAddress: true })),
    false
  );
}

export const isIpPublic = function isIpPublic(value) {
  if (value) {
    const noPort = value.substr(0, value.lastIndexOf(':'));

    const validIp = isIpValid(value, { returnAddress: true });
    const validNoPort = isIpValid(noPort, { returnAddress: true });
    return (validIp && !isPrivate(validIp)) || (validNoPort && !isPrivate(validNoPort));
  }

  return true;
};

export default {
  message: 'The provided IP address must be publicly accessible.',
  fn: isIpPublic
};
